export default __webpack_public_path__ + "assets/usRound.f713ab4a.svg";